<template>
	<div class="mainBox">
		<div class="topNav">
			<van-nav-bar safe-area-inset-top :placeholder="true" :fixed="true" title="巡检详情" left-text="返回" left-arrow
				@click-left="goBack">
			</van-nav-bar>
		</div>
		<div class="projectItem">
			<van-row gutter="10" class="notesTop">
				<van-col span="6">
					<div class="patrolLabel isBgDarkOrange">{{ record.majorName }}</div>
					<div class="patrolLabel isBgBlue">{{ record.categoryName }}</div>
				</van-col>
				<van-col span="18">
					<div class="patrolTitle">{{ record.subjectName }}</div>
				</van-col>
			</van-row>
			<div class="patrolTime">{{ record.inspectionTime | formatDate('yyyy-MM-dd') }} {{ record.inspectionMan }}</div>
			<div class="problemDetailItem"> <span>巡检内容</span>{{ record.inspectionContent }}</div>
			<van-row gutter="20">
				<!-- <van-col span="12">
					<div class="problemDetailItem"><span>提出时间</span>{{ record.inspectionTime }}</div>
				</van-col>
				<van-col span="12">
					<div class="problemDetailItem"><span>提出人</span>{{ record.inspectionMan }}</div>
				</van-col> -->
				<van-col span="24">
					<div class="problemDetailItem"><span>问题描述及整改意见</span>{{ record.sutContent }}</div>
				</van-col>
				<van-col span="12">
					<div class="problemDetailItem"><span>封闭人</span> {{ record.closeMan }}</div>
				</van-col>
				<van-col span="12">
					<div class="problemDetailItem"><span>封闭时间</span>{{ record.closeTime | formatDate('yyyy-MM-dd') }}</div>
				</van-col>
				<van-col span="24">
					<div class="problemDetailItem"><span>备注</span> {{ record.remark }}</div>
				</van-col>
			</van-row>
		</div>
		<!-- 1：有问题未封闭，3：有问题已封闭 -->
		<!-- <div v-if="record.closeState === '0' || record.closeState === '1'" class="projectItem">
			<div class="problemSituation">
				问题情况
				<div class="problemState01" v-if="record.closeState == '0'">未封闭</div>
				<div class="problemState02" v-if="record.closeState == '1'">已封闭</div>
			</div>
			<van-row gutter="20">
				<van-col span="12">
					<div class="problemDetailItem"><span>封闭时间</span>{{ record.closeTime | formatDate('yyyy-MM-dd') }}</div>
				</van-col>
				<van-col span="12">
					<div class="problemDetailItem"><span>封闭人</span> {{ record.closeMan }}</div>
				</van-col> -->
		<!-- <van-col span="12">
					<div class="problemDetailItem">
						<span :class="{isRedText: record.problem.iptFlg === '2', isOrangeText: record.problem.iptFlg === '1'}">{{record.problem.iptFlgName}}</span>
					</div>
				</van-col> -->
		<!-- </van-row>
			<div class="patrolDesc">{{ record.sutContent }}</div> -->
		<!-- <van-row gutter="20">
				<van-col span="8" v-for="(img, index) in record.problem.afterPhotoList" :key="index">
					<van-image width="2.5rem" height="2.5rem" fit="cover" :src="img.fileUri" />
				</van-col>
			</van-row> -->
		<!-- </div> -->
		<div class="projectItem">
			<div class="notesTop">
				整改前照片
			</div>
			<van-row gutter="20" style="margin-top: 10px;">
				<van-col span="8" v-for="(img, index) in record.scenePhotoList" :key="index">
					<van-image width="2.5rem" height="2.5rem" fit="cover" :src="img.fileUri" />
				</van-col>
			</van-row>
		</div>
		<div class="projectItem">
			<div class="notesTop">
				整改后照片
			</div>
			<van-row gutter="20"  style="margin-top: 10px;">
				<van-col span="8" v-for="(img, index) in record.closePhotoList" :key="index">
					<van-image width="2.5rem" height="2.5rem" fit="cover" :src="img.fileUri" />
				</van-col>
			</van-row>
		</div>
	</div>
</template>
<script>
import { info } from '../../api/qualityPatrol'
import { Notify } from 'vant';
import common from '../../utils/common';

export default {
	name: 'qualityPatrolDetail',
	data() {
		return {
			record: '',
			id: '',
			// 范畴名称
			categoryName: '',
			// 项目名称
			projectName: '',
		}
	},
	mounted() {
		this.project = common.getProject();
		if (this.project == null || this.project == undefined) {
			Notify({ type: 'danger', message: '获取项目信息失败' });
		}
		this.projectName = this.project.projectName
		this.id = this.$route.query.id;
		this.getDetail(this.id)
	},
	filters: {
		formatDate: function (value, args) {
			if (!value) {
				return ''
			}
			var dt = new Date(value);
			if (args == 'yyyy-M-d') {// yyyy-M-d
				let year = dt.getFullYear();
				let month = dt.getMonth() + 1;
				let date = dt.getDate();
				return `${year}-${month}-${date}`;
			} else if (args == 'yyyy-M-d H:m:s') {// yyyy-M-d H:m:s
				let year = dt.getFullYear();
				let month = dt.getMonth() + 1;
				let date = dt.getDate();
				let hour = dt.getHours();
				let minute = dt.getMinutes();
				let second = dt.getSeconds();
				return `${year}-${month}-${date} ${hour}:${minute}:${second}`;
			} else if (args == 'yyyy-MM-dd') {// yyyy-MM-dd
				let year = dt.getFullYear();
				let month = (dt.getMonth() + 1).toString().padStart(2, '0');
				let date = dt.getDate().toString().padStart(2, '0');
				return `${year}-${month}-${date}`;
			} else {// yyyy-MM-dd HH:mm:ss
				let year = dt.getFullYear();
				let month = (dt.getMonth() + 1).toString().padStart(2, '0');
				let date = dt.getDate().toString().padStart(2, '0');
				let hour = dt.getHours().toString().padStart(2, '0');
				let minute = dt.getMinutes().toString().padStart(2, '0');
				let second = dt.getSeconds().toString().padStart(2, '0');
				return `${year}-${month}-${date} ${hour}:${minute}:${second}`;
			}
		}
	},
	methods: {
		getSutConclusionName(id) {
			if (id == '0') {
				return '不合格';
			} else if (id == '1') {
				return '合格';
			} else {
				return '';
			}
		},
		getDetail(id) {
			info(id).then(response => {
				if (response.data.resultCode != 200) {
					Notify({ type: 'danger', message: response.data.resultMessage });
					return
				}
				this.record = response.data.body
				console.log("scene")
				console.log(this.record.scenePhotoList)
			})
		},
		goBack() {
			this.$router.push({
				name: 'qualityPatrolList'
			});
		}
	}
}
</script>
<style lang="scss" src="@/assets/sass/common.scss"></style>